import React, { useState, useEffect } from 'react';
import './Hack.css';
import Navbar from './Navbar';

const HackChecker = () => {
  const [deviceType, setDeviceType] = useState('');
  const [suspiciousActivity, setSuspiciousActivity] = useState('');
  const [symptoms, setSymptoms] = useState('');
  const [preventionMethods, setPreventionMethods] = useState('');
  const [userIP, setUserIP] = useState('');
  const [isScanning, setIsScanning] = useState(false);
  const [notification, setNotification] = useState('');

  useEffect(() => {
    fetchUserIP();
    detectDeviceType();
  }, []);

  const fetchUserIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      setUserIP(data.ip);
    } catch (error) {
      console.error('IP Fetch Error:', error);
    }
  };

  const detectDeviceType = () => {
    const ua = navigator.userAgent;
    if (/Android|iPhone|iPad|iPod|Windows Phone/i.test(ua)) {
      setDeviceType('Mobile');
    } else {
      setDeviceType('Desktop');
    }
  };

  const checkForSuspiciousActivity = () => {
    const isBot = /bot|crawl|spider|headless|selenium|phantom/i.test(navigator.userAgent);
    const symptomsText = [
      '- Unusual battery drain',
      '- Slow performance',
      '- Unexplained data usage',
      '- Pop-ups or ads',
      '- Apps crashing or acting strange'
    ].join('\n');

    const preventionText = [
      '- Use strong, unique passwords',
      '- Enable two-factor authentication',
      '- Keep your OS and apps updated',
      '- Avoid suspicious downloads or links',
      '- Use antivirus/firewall software'
    ].join('\n');

    setSymptoms(symptomsText);
    setPreventionMethods(preventionText);

    if (isBot) {
      setSuspiciousActivity('⚠️ Suspicious behavior detected (possible automation/bot).');
      setNotification('Possible compromise detected. Please review your security settings.');
      startScan(true);
    } else {
      setSuspiciousActivity('✅ No suspicious behavior detected.');
      setNotification('');
      startScan(false);
    }
  };

  const startScan = (isThreat) => {
    setIsScanning(true);
    setTimeout(() => {
      setIsScanning(false);
      alert(isThreat ? 'Potential issues found. Please review security tips.' : 'Scan complete. No threats found.');
    }, 4000);
  };

  return (
    <div className="boddy">
      <div className="bodyy">
        <div className="Appp">
          <h1>🛡️ Device Hack Checker</h1>
          
          {notification && <div className="notification">{notification}</div>}

          {isScanning && (
            <div className="scanning-animation">
              <div className="scan-bar"></div>
              <p>Scanning your device...</p>
            </div>
          )}

          <div className="info"><strong>Device Type:</strong> {deviceType}</div>
          <div className="info"><strong>Your IP:</strong> {userIP}</div>
          <div className="info"><strong>Suspicious Activity:</strong> {suspiciousActivity}</div>

          <div className="details">
            <strong>Symptoms of a Hacked Device:</strong>
            <pre>{symptoms}</pre>
          </div>

          <div className="details">
            <strong>Prevention Tips:</strong>
            <pre>{preventionMethods}</pre>
          </div>

          <button className="check-btn" onClick={checkForSuspiciousActivity}>
            Run Hack Check
          </button>
        </div>
      </div>
      <Navbar />

    </div>
  );
};

export default HackChecker;
